
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-19619.707 -13764.7 16.725 23.595"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Group_8083","data-name":"Group 8083","transform":"translate(-19618.884 -13764)"}},[_c('path',{staticClass:"cls-1",attrs:{"id":"Path_606","d":"M5.932 21.153a6.843 6.843 0 0 0-2.787-1.9C1.7 18.886.99 20 2.4 22.193a60.243 60.243 0 0 0 4.72 6.466 5.242 5.242 0 0 0 7.024 1.189 5.412 5.412 0 0 0 2.456-4.867c0-.111.037-2.973.037-2.973 0-1.524-.409-2.081-1.078-2.267-.595-.149-1.524.111-1.524 1.524v-1.227a1.447 1.447 0 0 0-1.3-1.6 1.065 1.065 0 0 0-1.3 1.189v-.26a1.408 1.408 0 0 0-1.412-1.524 1.24 1.24 0 0 0-1.375 1.264v-4.42A1.354 1.354 0 0 0 7.27 13.2c-.632 0-1.338.334-1.338 1.747z","data-name":"Path 606","transform":"translate(-1.436 -8.703)"}}),_c('path',{staticClass:"cls-1",attrs:{"id":"Line_86","d":"M0 2.49V0","data-name":"Line 86","transform":"translate(5.76)"}}),_c('path',{staticClass:"cls-1",attrs:{"id":"Line_87","d":"M2.416 0L0 .483","data-name":"Line 87","transform":"translate(0 7.061)"}}),_c('path',{staticClass:"cls-1",attrs:{"id":"Line_88","d":"M1.932 1.524L0 0","data-name":"Line 88","transform":"translate(1.003 2.75)"}}),_c('path',{staticClass:"cls-1",attrs:{"id":"Line_89","d":"M0 0l2.416.483","data-name":"Line 89","transform":"translate(9.588 7.061)"}}),_c('path',{staticClass:"cls-1",attrs:{"id":"Line_90","d":"M0 1.524L1.932 0","data-name":"Line 90","transform":"translate(9.068 2.75)"}})])])
          )
        }
      }
    